export const AI_MODELS = [
  // Fallback Models
  'relif-fallback-premium',
  'relif-fallback-claude',
  'relif-fallback-gemini',
  'relif-fallback-openai',
  'relif-fallback-grok',
  'relif-fallback-cheaper',
  'relif-fallback-default',
  'relif-fallback-expensive',
  'relif-fallback-faster',
  'relif-fallback-long-prompts',
  // OpenAI Models
  'gpt-5.6-sol',
  'gpt-5.6-sol-none',
  'gpt-5.6-sol-low',
  'gpt-5.6-sol-medium',
  'gpt-5.6-sol-high',
  'gpt-5.6-terra',
  'gpt-5.6-terra-none',
  'gpt-5.6-terra-low',
  'gpt-5.6-terra-medium',
  'gpt-5.6-terra-high',
  'gpt-5.6-luna',
  'gpt-5.6-luna-none',
  'gpt-5.6-luna-low',
  'gpt-5.6-luna-medium',
  'gpt-5.6-luna-high',
  'gpt-5.5',
  'gpt-5.5-none',
  'gpt-5.5-low',
  'gpt-5.5-medium',
  'gpt-5.5-high',
  'gpt-5.2',
  'gpt-5.2-none',
  'gpt-5.2-low',
  'gpt-5.2-medium',
  'gpt-5.2-high',
  'gpt-5.4',
  'gpt-5.4-mini',
  'gpt-5.4-nano',
  // Groq Models
  'meta-llama/llama-4-scout-17b-16e-instruct',
  'moonshotai/kimi-k2-instruct',
  'openai/gpt-oss-20b',
  'openai/gpt-oss-120b',
  // Gemini Models
  'gemini-3.1-pro-preview-high',
  'gemini-3.1-pro-preview-low',
  'gemini-3.6-flash',
  'gemini-3-flash-preview',
  'gemini-3.5-flash-lite',
  'gemini-3.1-flash-lite',
  // XAI Models
  'grok-4.3-low',
  'grok-4.3-medium',
  'grok-4.3-high',
  'grok-4.5',
  // Amazon Models
  'us.amazon.nova-premier-v1:0',
  'amazon.nova-pro-v1:0',
  'amazon.nova-lite-v1:0',
  'amazon.nova-micro-v1:0',
  'mistral-medium-latest',
  // Anthropic Models
  'claude-haiku-4-5',
  'claude-haiku-4-5-no-thinking',
  'claude-opus-5',
  'claude-opus-5-no-thinking',
  'claude-sonnet-5',
  'claude-sonnet-5-no-thinking',
  'claude-sonnet-4-6',
  'claude-sonnet-4-6-no-thinking',
  'claude-sonnet-4-5',
  'claude-sonnet-4-5-no-thinking',
  // DeepSeek Models
  'deepseek-reasoner',
  'deepseek-chat',
  'deepseek-v4-flash',
  // Relif Ideal Models
  'relif-ensemble-model-low',
  'relif-ensemble-model-medium',
  'relif-ensemble-model-high',
  'gpt-5.2-low-vs-grok-4.3-low',
  'relif-fallback-faster-vs-deepseek-v4-flash',
] as const;

export const DEFAULT_AI_MODEL = 'gpt-5.2-none';
export const DEFAULT_EVALUATION_AI_MODEL = 'gemini-3.1-pro-preview-low';

/**
 * Output cost in USD per 1M completion tokens, mirrored from
 * apps/saas_back/src/data/costConstants.ts (AI_MODELS_COSTS). Used only to bucket models into
 * affordability tiers ($ … $$$$) in pickers — not for real billing.
 */
const OUTPUT_COST_PER_MM: Record<string, number> = {
  'gpt-5.6-sol': 30,
  'gpt-5.6-sol-none': 30,
  'gpt-5.6-sol-low': 30,
  'gpt-5.6-sol-medium': 30,
  'gpt-5.6-sol-high': 30,
  'gpt-5.6-terra': 12,
  'gpt-5.6-terra-none': 12,
  'gpt-5.6-terra-low': 12,
  'gpt-5.6-terra-medium': 12,
  'gpt-5.6-terra-high': 12,
  'gpt-5.6-luna': 1.2,
  'gpt-5.6-luna-none': 1.2,
  'gpt-5.6-luna-low': 1.2,
  'gpt-5.6-luna-medium': 1.2,
  'gpt-5.6-luna-high': 1.2,
  'gpt-5.5': 30,
  'gpt-5.5-none': 30,
  'gpt-5.5-low': 30,
  'gpt-5.5-medium': 30,
  'gpt-5.5-high': 30,
  'gpt-5.2': 14,
  'gpt-5.2-none': 14,
  'gpt-5.2-low': 14,
  'gpt-5.2-medium': 14,
  'gpt-5.2-high': 14,
  'gpt-5.4': 15,
  'gpt-5.4-mini': 4.5,
  'gpt-5.4-nano': 1.25,
  'meta-llama/llama-4-scout-17b-16e-instruct': 0.34,
  'moonshotai/kimi-k2-instruct': 3,
  'openai/gpt-oss-20b': 0.5,
  'openai/gpt-oss-120b': 0.75,
  'gemini-3.1-pro-preview-high': 12,
  'gemini-3.1-pro-preview-low': 12,
  'gemini-3.6-flash': 7.5,
  'gemini-3-flash-preview': 3,
  'gemini-3.5-flash-lite': 2.5,
  'gemini-3.1-flash-lite': 0.4,
  'grok-4.3-low': 2.5,
  'grok-4.3-medium': 2.5,
  'grok-4.3-high': 2.5,
  'grok-4.5': 6,
  'us.amazon.nova-premier-v1:0': 4,
  'amazon.nova-pro-v1:0': 3.2,
  'amazon.nova-lite-v1:0': 0.24,
  'amazon.nova-micro-v1:0': 0.14,
  'mistral-medium-latest': 2,
  'claude-opus-5': 25,
  'claude-haiku-4-5': 3,
  'claude-sonnet-5': 15,
  'claude-sonnet-4-6': 15,
  'claude-sonnet-4-5': 15,
  'deepseek-reasoner': 2.19,
  'deepseek-chat': 0.28,
};

export type CostTier = '$' | '$$' | '$$$' | '$$$$';

/**
 * Affordability tier from output cost: $ cheap, $$ medium, $$$ expensive, $$$$ way expensive.
 * Returns null for proxies (fallback/ensemble) and unknown models. `-no-thinking` shares base pricing.
 */
export const getCostTier = (model: string): CostTier | null => {
  const base = model.replace(/-no-thinking$/, '');
  const cost = OUTPUT_COST_PER_MM[base];
  if (cost == null) {
    return null;
  }
  if (cost < 1.5) {
    return '$';
  }
  if (cost < 6) {
    return '$$';
  }
  if (cost < 18) {
    return '$$$';
  }
  return '$$$$';
};
